module.exports = __webpack_public_path__ + "media/images/leadership_characteristics/bg-5-ecd2baeb6b423bb86e3a5f9aa8ca49cd.png";